import React, { useState } from "react";
import CommonFilterSelect, {
  FilterTypes,
  initialFilters,
} from "../../../core/common/CommonFilterSelect";
import InputField from "../../../core/common/form-fields/InputField";
import { ErrorType } from "../../../types/common-type";
import { validateForm } from "../../../core/validations/Validation_singleInvite";
import { InputDateField } from "../../../core/common/form-fields/InputDateField";
import handleClearError from "../../../core/methods/handleClearError";
import ErrorMessage from "../../../core/common/ErrorMessage";
import { usePackageByDepartmentId } from "../../../core/customhook/hooks/packageHooks";
import Loading from "../../../core/common/custom-loading/Loading";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import Swal from "sweetalert2";

interface InvitePayloadProps {
  org_id: string;
  package_id: string;
  program_id: string;
  department_id: string;
  projectId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  applicantEmailId: string;
  applicantMobileNumber: string;
  dateOfBirth: string;
  gender: string;
  fatherNameMotherName: string;
  uan_no: string;
  aadharNumber: string;
  aadhar_pincode: string;
  address_pincode: string;
  pan_no: string;
  address1: string;
  address2: string;
  crn_no: string;
  hrmsId: string;
  employeeId: string;
  joiningDate: string;
  spocName: string; 
  project_id: string;
}

const initialState = {
  first_name: "",
  middle_name: "",
  last_name: "",
  applicant_email: "",
  applicant_mobile: "",
  dob: "",
  gender: "",
  parent_name: "",
  uan_no: "",
  aadharNumber: "",
  aadhar_pincode: "",
  address_pincode: "",
  pan_no: "",
  address1: "",
  address2: "",
  crn_no: "",
  hrmsId: "",
  employeeId: "",
  joiningDate: "",
  spocName: "",
  project_id:"",
};

const SingleInvite = () => {
  const [filterData, setFilterData] = useState<FilterTypes>(initialFilters);
  const [errors, setErrors] = useState<ErrorType | null>(null);
  const [formData, setFormData] = useState(initialState);

  const { selectedItem: selectedPackage, loading: loadingPackage } = usePackageByDepartmentId(filterData?.department, filterData?.package);

  const { callApi, loading: loadingCreate } = useApi<any>(
    webservice_url.createSingleInvite,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );
 
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
    handleClearError(setErrors, name);
  };

  const handleDateChange = (name: string, value: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    handleClearError(setErrors, name);
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = validateForm({ formData, setErrors });
    if (!isValid) return;

    try {
      const payload: InvitePayloadProps = {
        org_id: filterData?.organization ?? "",
        projectId: filterData?.project ?? "",
        package_id: filterData?.package ?? "",
        program_id: filterData?.program ?? "",
        department_id: filterData?.department ?? "",
        firstName: formData?.first_name ?? "",
        middleName: formData?.middle_name ?? "",
        lastName: formData?.last_name ?? "",
        applicantEmailId: formData?.applicant_email ?? "",
        applicantMobileNumber: formData?.applicant_mobile ?? "",
        dateOfBirth: formData?.dob ?? "",
        gender: formData?.gender ?? "",
        fatherNameMotherName: formData?.parent_name ?? "",
        uan_no: formData?.uan_no?.trim() ?? "",
        aadharNumber: formData?.aadharNumber?.trim() ?? "",
        pan_no: formData?.pan_no?.trim().toUpperCase() ?? "",
        address1: formData?.address1?.trim() ?? "",
        address_pincode: formData?.address_pincode ?? "",
        aadhar_pincode: formData?.aadhar_pincode ?? "",
        address2: formData?.address2?.trim() ?? "",
        crn_no: formData?.crn_no?.trim() ?? "",
        hrmsId: formData?.hrmsId?.trim() ?? "",
        employeeId: formData?.employeeId?.trim() ?? "",
        joiningDate: formData?.joiningDate ?? "",
        spocName: formData?.spocName?.trim() ?? "",
        project_id: filterData.project ?? "", 
      };
      const res = await callApi(payload);

      if (res?.success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: res?.message || "Invite created successfully!",
          confirmButtonText: "OK",
          confirmButtonColor: "#f26522",
        });

        setFormData(initialState);
      }
    } catch (error: any) {
      console.error("Submission failed:", error);

      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Invite failed";

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: message,
        confirmButtonText: "OK",
        confirmButtonColor: "#d33",
      });
    }
  };

  const sharedProps = {
    data: formData,
    onChange: handleChange,
    colClass: "col-6 col-md-4",
    errors: errors,
  };

  return (
    <div>
      <div className="fw-semibold text-dark mb-3 pt-2">Step 1</div>

      <CommonFilterSelect
        colClass={"col-6 col-sm-4 col-md-3 col-xl-2"}
        handleGetFilters={(data) => setFilterData(data)}
      />

      {!loadingPackage && !filterData?.package && <div className=""></div>}
      {loadingPackage && !!filterData?.package && <Loading />}
      {!loadingPackage && !!filterData?.package && (
        <div className="mt-4">
          {selectedPackage?.sop && (
            <>
              <div className=" mb-2 fw-semibold text-dark  pt-2">
                Package Scope
              </div>
              <div className=" p-2 text-dark border rounded-3">
                {selectedPackage?.sop}
              </div>
            </>
          )}

          <div className="mt-4 pt-3 fw-semibold text-dark mb-2">Step 2:</div>
          <div className="col-6 col-md-4 mb-3">
            <label htmlFor="Submit-Link" className="form-label formfield-label">
              Submit upload link to <span className="text-danger">*</span>
            </label>
            <select
              id="link"
              name="link" 
              className={`form-select select_field formfield-control ${
                errors?.link ? "is-invalid" : ""
              }`.trim()} 
            >
              <option value="Candidate">Candidate</option> 
            </select>
            {errors?.link && <ErrorMessage message={errors?.link} />}
          </div>

          <div className="mt-3">
            <div className="fw-semibold text-dark mb-3 pt-2">Step 3</div>
            <form onSubmit={handleFormSubmit}>
              <div className="card">
                <div className="card-header">
                  <h5>Applicant Details</h5>
                </div>
                <div className="card-body p-3 row my-0 gx-2 ">
                  <InputField<any>
                    {...sharedProps}
                    label="First Name"
                    name="first_name"
                    className="text-capitalize"
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Middle Name"
                    name="middle_name"
                    className="text-capitalize"
                    disabled={loadingCreate}
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Last Name"
                    name="last_name"
                    className="text-capitalize"
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    type="email"
                    name="applicant_email"
                    label="Applicant Email ID"
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Applicant Mobile Number"
                    name="applicant_mobile"
                    inputMode="numeric"
                    maxLength={10}
                    disabled={loadingCreate}
                    required
                  />

                  <InputDateField
                    {...sharedProps}
                    label="Date of Birth"
                    name="dob"
                    onChange={handleDateChange}
                    disabled={loadingCreate}
                    required
                  />

                  <div className="col-6 col-md-4 mb-3">
                    <label
                      htmlFor="gender"
                      className="form-label fw-bold text-dark"
                    >
                      Gender <span className="text-danger">*</span>
                    </label>

                    <select
                      name="gender"
                      value={formData.gender || ""}
                      onChange={handleChange}
                      className="form-select form-select-sm mb-1"
                      disabled={loadingCreate}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>

                    {errors?.gender && (
                      <ErrorMessage message={errors?.gender} />
                    )}
                  </div>

                  <InputField<any>
                    {...sharedProps}
                    label="Father Name"
                    name="parent_name"
                    className="text-capitalize"
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="UAN No."
                    name="uan_no"
                    inputMode="numeric"
                    maxLength={12}
                    disabled={loadingCreate}
                    // required
                  />
                  <InputField<any>
                    {...sharedProps}
                    label="PAN No."
                    name="pan_no"
                    className="text-uppercase"
                    maxLength={10}
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Aadhar Card Number"
                    name="aadharNumber"
                    inputMode="numeric"
                    maxLength={12}
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Aadhar Address"
                    name="address1"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                    required
                  />
                  <InputField<any>
                    {...sharedProps}
                    label="Aadhar Address Pincode"
                    name="aadhar_pincode"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Applicant Address"
                    name="address2"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                    // required
                  />
                  <InputField<any>
                    {...sharedProps}
                    label="Applicant Address Pincode"
                    name="address_pincode"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                    // required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Applicant Registration Number (CRN)"
                    name="crn_no"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Candidate ID"
                    name="hrmsId"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="Worker ID"
                    name="employeeId"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                  />

                  <InputDateField
                    {...sharedProps}
                    label="Hire Date"
                    name="joiningDate"
                    onChange={handleDateChange}
                    disabled={loadingCreate}
                    required
                  />

                  <InputField<any>
                    {...sharedProps}
                    label="SPOC Name"
                    name="spocName"
                    colClass="col-12 col-md-4"
                    disabled={loadingCreate}
                    required
                  />
                </div>
                <div className="card-footer text-end">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loadingCreate}
                  >
                    {loadingCreate ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleInvite; 